__turbopack_context__.v({
  "cardGrid": "company-staff-section-module__rLZ2Sa__cardGrid",
  "header": "company-staff-section-module__rLZ2Sa__header",
  "tabWrap": "company-staff-section-module__rLZ2Sa__tabWrap",
});
